import service from '@/base/service'

const baseURL = process.env.VUE_APP_BASE_API_AI
const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}

export function selectCompanyByAccount (postData) {
  return service({
    url: '/tcloud-account/account/selectCompanyByAccount',
    method: 'POST',
    data: postData
  })
}

export function GetUser_WorkForEmployee (postData) {
  return service({
    url: '/aggregateservice-web/api/User_Work/GetUser_WorkForEmployee',
    method: 'POST',
    data: postData
  })
}

export function CheckTTService (postData) {
  return service({
    url: '/aggregateservice-web/api/Home/CheckTTService',
    method: 'POST',
    data: postData
  })
}
export function OpenTT (postData) {
  return service({
    url: '/aggregateservice-web/api/Home/OpenTT',
    method: 'POST',
    data: postData
  })
}

export function SetTTStatus (postData) {
  return service({
    url: '/aggregateservice-web/api/Home/SetTTStatus',
    method: 'POST',
    data: postData
  })
}

export function GetTTUrl (postData) {
  return service({
    url: '/aggregateservice-web/api/Home/GetTTUrl',
    method: 'POST',
    data: postData
  })
}
// 获取引流工具-概况-产品/图片素材详情  数据
export function GetGaikuangPicDetail (postData) {
  return service({
    url: '/aggregateservice-web/v1.0.0/api/Speed_Keyword/GetMaterialData',
    method: 'post',
    data: postData
  })
}

// 线索额度统计
// eslint-disable-next-line import/prefer-default-export
export function cueQuotaStatistics () {
  return request({
    url: '/home/cueQuotaStatistics',
    method: 'get'
  })
}

// 员工解锁排行
export function employeeUnLockRank () {
  return request({
    url: '/home/employeeUnLockRank',
    method: 'get'
  })
}

// 最近访问
// export function recentViewCompany () {
//   return request({
//     url: '/home/recentViewCompany',
//     method: 'get'
//   })
// }
// 最近访问 - HID
export function recentViewCompany () {
  return request({
    url: '/vv5/home/recentViewCompany',
    method: 'get'
  })
}

// 销售动态
export function salesData () {
  return request({
    url: '/home/salesData',
    method: 'get'
  })
}

// 商机订阅
export function subscribeBusiness () {
  return request({
    url: '/home/subscribeBusiness',
    method: 'get'
  })
}

// 全部动态
// export function unlockCompany (data) {
//   return request({
//     url: '/home/unlockCompany',
//     method: 'post',
//     data
//   })
// }
// 全部动态 - HID
export function unlockCompany (data) {
  return request({
    url: '/vv5/home/unlockCompany',
    method: 'post',
    data
  })
}

// 解锁来源统计
export function unlockSource () {
  return request({
    url: '/home/unlockSource',
    method: 'get'
  })
}

// test
export function testUserInfo () {
  return request({
    url: 'home/testUserInfo',
    method: 'get'
  })
}
